module.exports = __webpack_public_path__ + "mouse.jpg?1836f751b22df56a37abade47bb96d66";